export type FieldErrors = Record<string, string>;

/** Alias for form drivers; same shape as {@link FieldErrors}. */
export type FormFieldErrors = FieldErrors;

export function clearFormFieldError(errors: FormFieldErrors, fieldId: string): FormFieldErrors {
  if (!(fieldId in errors)) return errors;
  const next = { ...errors };
  delete next[fieldId];
  return next;
}

export function clearFormFieldErrors(errors: FormFieldErrors, ...fieldIds: string[]): FormFieldErrors {
  let next = errors;
  for (const fieldId of fieldIds) next = clearFormFieldError(next, fieldId);
  return next;
}

export function patchRecord<T extends Record<string, unknown>>(
  record: T,
  errors: FormFieldErrors,
  patch: Partial<T>,
  ...clearIds: string[]
): { record: T; errors: FormFieldErrors } {
  return { record: { ...record, ...patch }, errors: clearFormFieldErrors(errors, ...clearIds) };
}

export function firstFieldError(errors: FieldErrors): string | null {
  for (const msg of Object.values(errors)) {
    if (msg) return msg;
  }
  return null;
}
